//* Libraries imports
import React from "react";
import { Container } from "@mui/material";

//* Components Imports
import ScrollTransition from "components/ScrollTransition";

//* Styles Imports
import styles from "./styles.module.css";

//* Assets Imports
import deliveryVehiclesImg from "assets/static/landing/delivery_vehicles.png";

//* Icons Imports
import TwoWheelerIcon from "@mui/icons-material/TwoWheeler";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

function LogisticsSection() {
  return (
    <section
      id="custom-logistics-section"
      data-testid="custom-logistics-section"
      aria-label="Seção sobre logística sob medida para entrega de materiais"
      className={styles.logisticsSection}
    >
      <Container
        id="logistics-container"
        data-testid="logistics-container"
        aria-label="Container da logística sob medida"
        maxWidth="xl"
      >
        <div
          id="logistics-grid"
          data-testid="logistics-grid"
          aria-label="Layout dividido da logística"
          className={styles.logisticsGrid}
        >
          <div
            id="logistics-text-container"
            data-testid="logistics-text-container"
            aria-label="Textos explicativos de logística"
            className={styles.logisticsTextContainer}
          >
            <ScrollTransition
              id="logistics-title-transition"
              data-testid="logistics-title-transition"
              aria-label="Animação do título da logística"
            >
              <h2
                id="logistics-title"
                data-testid="logistics-title"
                aria-label="Título: Logística Sob Medida"
                className={styles.sectionTitle}
                style={{ textAlign: "left" }}
              >
                <span className={styles.highlight}>Logística Sob</span> medida
              </h2>
              <div
                id="logistics-divider"
                data-testid="logistics-divider"
                aria-label="Linha decorativa da logística"
                className={styles.divider}
                style={{ margin: "1rem 0" }}
              />
            </ScrollTransition>

            <ScrollTransition
              id="logistics-desc-transition"
              data-testid="logistics-desc-transition"
              aria-label="Animação da descrição e distância da logística"
              delay={200}
            >
              <h3
                id="logistics-subtitle"
                data-testid="logistics-subtitle"
                aria-label="Subtítulo: Configuração de Frete"
                className={styles.sectionSubtitle}
              >
                CONFIGURAÇÃO DE FRETE
              </h3>
              <p
                id="logistics-description"
                data-testid="logistics-description"
                aria-label="Informações sobre a abrangência da logística"
                className={styles.logisticsDescText}
              >
                Estabeleça o <span className={styles.highlight}>raio de distância</span> (KM) que sua loja irá atender.
              </p>
              <div
                id="logistics-distance-box"
                data-testid="logistics-distance-box"
                aria-label="Detalhes sobre a distância de entrega"
                className={styles.distanceBox}
              >
                <p
                  id="logistics-distance-text"
                  data-testid="logistics-distance-text"
                  aria-label="Defina taxas fixas personalizadas"
                  className={styles.distanceText}
                >
                  Defina taxas fixas personalizadas para:
                </p>
              </div>
            </ScrollTransition>

            <ScrollTransition
              id="logistics-bullets-transition"
              data-testid="logistics-bullets-transition"
              aria-label="Animação da lista de veículos de entrega"
              delay={300}
            >
              <ul
                id="logistics-bullets-list"
                data-testid="logistics-bullets-list"
                aria-label="Tipos de veículos"
                className={styles.bulletsList}
              >
                <li
                  id="bullet-moto"
                  data-testid="bullet-moto"
                  aria-label="Veículo: Moto"
                  className={styles.bulletItem}
                >
                  <div
                    id="bullet-moto-icon-container"
                    data-testid="bullet-moto-icon-container"
                    aria-label="Container do ícone de moto"
                    className={styles.bulletIconContainer}
                  >
                    <TwoWheelerIcon
                      id="bullet-moto-icon"
                      data-testid="bullet-moto-icon"
                      aria-label="Ícone de moto"
                      className={styles.bulletIcon}
                    />
                  </div>
                  <div
                    id="bullet-moto-text"
                    data-testid="bullet-moto-text"
                    aria-label="Detalhamento da entrega por moto"
                    className={styles.bulletTextWrapper}
                  >
                    <strong className={styles.vehicleType}>Moto</strong>
                  </div>
                </li>

                <li
                  id="bullet-car"
                  data-testid="bullet-car"
                  aria-label="Veículo: Carro Pick-up"
                  className={styles.bulletItem}
                >
                  <div
                    id="bullet-car-icon-container"
                    data-testid="bullet-car-icon-container"
                    aria-label="Container do ícone de pick-up"
                    className={styles.bulletIconContainer}
                  >
                    <DirectionsCarIcon
                      id="bullet-car-icon"
                      data-testid="bullet-car-icon"
                      aria-label="Ícone de carro"
                      className={styles.bulletIcon}
                    />
                  </div>
                  <div
                    id="bullet-car-text"
                    data-testid="bullet-car-text"
                    aria-label="Detalhamento da entrega por carro pick-up"
                    className={styles.bulletTextWrapper}
                  >
                    <strong className={styles.vehicleType}>Carro Pick-up</strong>
                  </div>
                </li>

                <li
                  id="bullet-truck"
                  data-testid="bullet-truck"
                  aria-label="Veículo: Caminhão"
                  className={styles.bulletItem}
                >
                  <div
                    id="bullet-truck-icon-container"
                    data-testid="bullet-truck-icon-container"
                    aria-label="Container do ícone de caminhão"
                    className={styles.bulletIconContainer}
                  >
                    <LocalShippingIcon
                      id="bullet-truck-icon"
                      data-testid="bullet-truck-icon"
                      aria-label="Ícone de caminhão"
                      className={styles.bulletIcon}
                    />
                  </div>
                  <div
                    id="bullet-truck-text"
                    data-testid="bullet-truck-text"
                    aria-label="Detalhamento da entrega por caminhão"
                    className={styles.bulletTextWrapper}
                  >
                    <strong className={styles.vehicleType}>Caminhão</strong>
                  </div>
                </li>
              </ul>
            </ScrollTransition>
          </div>

          <div
            id="logistics-image-wrapper"
            data-testid="logistics-image-wrapper"
            aria-label="Imagem com a frota de veículos parceiros iGooB"
            className={styles.logisticsImageWrapper}
          >
            <ScrollTransition
              id="logistics-image-transition"
              data-testid="logistics-image-transition"
              aria-label="Animação da imagem dos veículos de entrega"
              delay={300}
            >
              <img
                id="logistics-image"
                data-testid="logistics-image"
                aria-label="Imagem da frota: Moto, Carro Pick-up e Caminhão"
                src={deliveryVehiclesImg}
                alt="Logística Sob Medida"
                className={styles.logisticsImage}
              />
            </ScrollTransition>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default LogisticsSection;
